import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AgentPage from "@/pages/AgentPage";
import AdminPage from "@/pages/AdminPage";
import PaymentResult from "@/pages/PaymentResult";
import ProfilePage from "@/pages/ProfilePage";
import SpotPage from "@/pages/SpotPage";
import LinkVideoPage from "@/pages/LinkVideoPage";
import { OfflineWatcher } from "@/components/OfflineWatcher";
import { AuthProvider, Protected } from "@/lib/auth";

export default function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
        <OfflineWatcher />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/admin" element={<AuthPage mode="admin" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/agent" element={<Protected><AgentPage /></Protected>} />
            <Route path="/app/spot" element={<Protected><SpotPage /></Protected>} />
            <Route path="/app/link" element={<Protected><LinkVideoPage /></Protected>} />
            <Route path="/app/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/app/admin" element={<Protected><AdminPage /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentResult /></Protected>} />
            <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid #dddfe2",
            color: "#050505",
            fontFamily: "Plus Jakarta Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}
